export class GroceryModel {
  constructor() {
    try {
      const savedGroceries = JSON.parse(localStorage.getItem('groceries'));
      if (!Array.isArray(savedGroceries) || !savedGroceries.every((item) => this._isValidItem(item))) {
        throw new Error('Invalid groceries payload');
      }
      this.groceries = savedGroceries;
    } catch {
      this.groceries = [
        { itemName: 'Apples', quantity: '5' },
        { itemName: 'Milk', quantity: '1 gallon' },
        { itemName: 'Bread', quantity: '2 loaves' },
      ];
    }
  }

  _isValidItem(item) {
    return (
      typeof item === 'object' &&
      item !== null &&
      typeof item.itemName === 'string' &&
      typeof item.quantity === 'string'
    );
  }

  _commit(groceries) {
    this.groceries = groceries;
    localStorage.setItem('groceries', JSON.stringify(groceries));
    this.onGroceryListChanged(groceries);
  }

  subscribeGroceryListChanged(callback) {
    this.onGroceryListChanged = callback;
  }

  addGrocery(itemName, quantity) {
    // productInfo starts null; the controller fills it in once the async fetch resolves.
    const newItem = { itemName, quantity, productInfo: null };
    this._commit([...this.groceries, newItem]);
  }

  updateProductInfo(index, productInfo) {
    this._commit(
      this.groceries.map((item, itemIndex) =>
        itemIndex === index ? { ...item, productInfo } : item
      )
    );
  }

  deleteGrocery(index) {
    this._commit(this.groceries.filter((_, groceryIndex) => groceryIndex !== index));
  }
}
